// src/lib/postedTimes.js — 승객 화면 «정류장 시각 미게시» 판정 (순수 함수 · import 0)
// ---------------------------------------------------------------------------
// 2026-11-02 게시판 `eFJo4tOK`(안재학): 퇴근 노선은 정류장별 시간을 일부러 비워 두는데
// 승객 화면이 그 자리를 거리로 계산한 예상 시각(computeStopEstimates 의 unplanned
// chain 전파)으로 채워 «18:03 · 18:07 …» 처럼 보였다.
//
// 규칙: 출발지를 뺀 정류장 중 시각(offsetMin)이 하나도 없으면 = 관리자가 «시각을
// 게시하지 않은» 노선 → 승객 화면에서 미설정 정류장(status 'unplanned')의 예상 시각·
// 지연을 지운다. 실제 도착(status 'arrived')은 사실이라 그대로 둔다.
//
// 🔴 일부 정류장만 시각을 넣은 노선은 건드리지 않는다 — 2026-05-26 «일부만 설정한
//    노선에서 예상시각이 영구 숨김» 결함을 고치려고 chain 전파를 넣은 것이라, 그 노선은
//    빈 칸도 예상 시각을 보여 주는 것이 맞다.
// 🔴 승객 화면(EmployeeApp·PassengerApp) 표시 전용 — 기사앱·관리자는 원본을 쓴다.
// ---------------------------------------------------------------------------

function hasOffset(s) {
  return !!s && typeof s.offsetMin === "number" && isFinite(s.offsetMin);
}

// stops: order 오름차순 정류장 배열. 출발지(0번) 외에 시각이 하나라도 있으면 true.
export function routePostsStopTimes(stops) {
  if (!Array.isArray(stops) || stops.length < 2) return true;
  for (let i = 1; i < stops.length; i++) {
    if (hasOffset(stops[i])) return true;
  }
  return false;
}

// computeStopEstimates 결과에서 미게시 노선의 미설정 정류장 시각을 지운다(새 배열).
export function hideUnpostedStopTimes(estimates, stops) {
  if (!Array.isArray(estimates)) return [];
  if (routePostsStopTimes(stops)) return estimates;
  return estimates.map((e) =>
    e && e.status === "unplanned"
      ? { ...e, estimatedAt: null, delaySec: null }
      : e
  );
}
